
export default {
  'zh-CN': {
    title: '提示',
    desc: '采购品类发生变更，采购需求说明是否按照新的采购品类要求重新填写？',
    cancelChange: '取消变更',
    ignore: '忽 略',
    fillAgain: '重新填写'
  },
  'en': {
    title: 'Tips',
    desc: 'If the purchase category changes, is the purchase demand description filled in again according to the requirements of the new purchase category?',
    cancelChange: 'Cancel Change',
    ignore: 'Ignore',
    fillAgain: 'Re fill'
  },
  'ja': {
    title: '提示',
    desc: '采购品类发生变更，采购需求说明是否按照新的采购品类要求重新填写？',
    cancelChange: '取消变更',
    ignore: '忽 略',
    fillAgain: '重新填写'
  }
}
